module.exports = __webpack_public_path__ + "static/img/workerfull-replacement.08fc762.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workerfull-replacement.jpg
// module id = SeOG
// module chunks = 62